'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Title } from '@radix-ui/react-dialog';
import { forwardRef } from 'react';
import { cn } from '../../utils/cn';
const DrawerTitle = forwardRef(({ className, ...props }, ref) => (_jsx(Title, { ref: ref, className: cn('text-body-1 font-semibold text-metal-900', className), ...props })));
DrawerTitle.displayName = Title.displayName;
export { DrawerTitle };
